import { Outlet, createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
// Keep other necessary imports like React, trpc, UI components if the layout itself uses them,
// but for a simple Outlet wrapper, many might not be needed directly in *this* file's layout component.
// The actual list component (to be moved to index.tsx) will retain its specific imports.

// Search schema is still relevant for the /_protected/calls path itself,
// even if the layout component is simple.
const callsSearchSchema = z.object({
  page: z.int().min(1).catch(1),
  startDate: z.iso.datetime({ offset: true }).optional(),
  endDate: z.iso.datetime({ offset: true }).optional(),
});

// This component will be the layout for /_protected/calls and its children
function CallsSectionLayout() {
  return (
    <div className="p-0">
      {' '}
      {/* Adjust padding/container as needed for the section */}
      {/* Optional: Add a section title or breadcrumbs here */}
      {/* <h1>Call History Section</h1> */}
      <Outlet />
    </div>
  );
}

export const Route = createFileRoute('/_protected/calls')({
  component: CallsSectionLayout, // Use the new layout component
  validateSearch: (search) => callsSearchSchema.parse(search),
  // The loader for fetching the *list* of calls will belong to the index route,
  // not this layout route.
});
